import React from 'react';
import { View } from 'app-studio';
import { DragAndDropViewProps } from './DragAndDrop.props';
// Defines the `DragAndDropView` functional component, responsible for rendering a list of draggable items and handling basic drag interactions.
export const DragAndDropView: React.FC<DragAndDropViewProps> = ({
  items,
  renderItem,
  containerProps,
  itemProps,
  draggedIndex,
  itemRefs,
  handleDragStart,
  views,
  themeMode: elementMode,
}) => (
  <View
    overflow="hidden"
    position="relative"
    {...containerProps}
    {...views?.container}
  >
    {items.map((item, index) => (
      <View
        key={index}
        ref={(el: HTMLElement | null) => {
          itemRefs.current[index] = el as HTMLDivElement | null;
        }}
        onMouseDown={(e: React.MouseEvent) => handleDragStart(e, index)}
        onTouchStart={(e: React.TouchEvent) => handleDragStart(e, index)}
        position="relative"
        cursor="grab"
        transition="transform 0.2s"
        {...itemProps}
        {...views?.item}
      >
        {renderItem ? renderItem(item, index) : item}
      </View>
    ))}
  </View>
);
